import React from "react";
import { useSelector } from "react-redux";
import { Alliance } from "../../../../lib/types";
import AllianceProfile from "./AllianceProfile";
import { DragescentState } from "../../../../store/reducers/stateType";

interface IProps {
  alliance: Alliance;
}

const OtherAllianceProfile = ({ alliance }: IProps) => {
  const ownAllianceId = useSelector((state: DragescentState) => state.governorate.alliance?.id);
  return (
    <AllianceProfile
      alliance={alliance}
      owner={alliance.id === ownAllianceId}
      war={alliance.war}
      opponent={alliance.opponent}
    />);
}

export default OtherAllianceProfile;
